const UPDATE_PHONE_PATTERN = /^\+?[0-9]{10,15}$/;
const CREATE_PHONE_PATTERN = /^\+?[1-9][0-9]{9,14}$/;
const PARENT_WHATSAPP_PATTERN = /^\+[1-9][0-9]{9,14}$/;

export const STUDENT_PHONE_ERROR =
  "Phone number must be 10–15 digits (optional leading +)";
export const INTERNATIONAL_PHONE_ERROR =
  "Phone number must be a valid international phone number";
export const PARENT_WHATSAPP_ERROR =
  "WhatsApp number must include country code (e.g. +91...)";

export function extractPhoneDigits(value) {
  return String(value ?? "").replace(/\D/g, "");
}

/** Normalize stored phone for react-phone-input-2 (digits only, no +). */
export function formatForPhoneInput(value, defaultCountryDial = "91") {
  const digits = extractPhoneDigits(value);
  if (!digits) return "";
  if (digits.length === 10 && defaultCountryDial) {
    return `${defaultCountryDial}${digits}`;
  }
  return digits;
}

export function formatWhatsappForPhoneInput(value) {
  return formatForPhoneInput(value);
}

function buildPhoneCandidate(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  const hadPlus = raw.startsWith("+");
  const digits = extractPhoneDigits(raw);
  if (!digits) return "";
  return hadPlus ? `+${digits}` : digits;
}

export function normalizeStudentPhoneForApi(value) {
  const candidate = buildPhoneCandidate(value);
  if (!candidate) return "";
  if (!UPDATE_PHONE_PATTERN.test(candidate)) return null;
  return candidate;
}

export function normalizeInternationalPhoneForApi(value) {
  const candidate = buildPhoneCandidate(value);
  if (!candidate) return "";
  if (!CREATE_PHONE_PATTERN.test(candidate)) return null;
  return candidate;
}

export function normalizeParentPhoneForApi(value) {
  const candidate = buildPhoneCandidate(value);
  if (!candidate) return "";
  if (candidate.length < 10 || candidate.length > 15) return null;
  return candidate;
}

export function normalizeParentWhatsappForApi(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  const digits = extractPhoneDigits(raw);
  if (!digits) return "";
  const candidate = `+${digits}`;
  if (!PARENT_WHATSAPP_PATTERN.test(candidate)) return null;
  return candidate;
}

export function validateStudentPhone(value, { required = true } = {}) {
  const raw = String(value ?? "").trim();
  if (!raw) {
    return required ? "Phone number is required" : null;
  }
  const candidate = buildPhoneCandidate(value);
  if (!UPDATE_PHONE_PATTERN.test(candidate)) {
    return STUDENT_PHONE_ERROR;
  }
  return null;
}

export function validateInternationalPhone(value, { required = true } = {}) {
  const raw = String(value ?? "").trim();
  if (!raw) {
    return required ? "Phone number is required" : null;
  }
  const candidate = buildPhoneCandidate(value);
  if (!CREATE_PHONE_PATTERN.test(candidate)) {
    return INTERNATIONAL_PHONE_ERROR;
  }
  return null;
}

export function validateParentPhone(value, { required = true } = {}) {
  const raw = String(value ?? "").trim();
  if (!raw) {
    return required ? "Phone number is required" : null;
  }
  const candidate = buildPhoneCandidate(value);
  if (candidate.length < 10 || candidate.length > 15) {
    return STUDENT_PHONE_ERROR;
  }
  return null;
}

export function validateParentWhatsapp(value, { required = true } = {}) {
  const raw = String(value ?? "").trim();
  if (!raw) {
    return required ? "Parent WhatsApp number is required" : null;
  }
  const digits = extractPhoneDigits(raw);
  const candidate = `+${digits}`;
  if (!PARENT_WHATSAPP_PATTERN.test(candidate)) {
    return PARENT_WHATSAPP_ERROR;
  }
  return null;
}
